import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EditableImageComponent } from '../../../base/image/editable-image/editable-image.component';
import { EditableButtonComponent } from '../../../base/button/editable-button/editable-button.component';
import { BaseComponent } from '../../base/base.component';
import { FileType } from '../../../../state-management/model/enums/state.enums';
import { ImageCoordinates } from '../../../../state-management/model/interfaces/screen-size.model';
import { CoordinatesSystem, ImageFormat, ScreenWidthBreakpoints } from '../../../../state-management/model/enums/screen-size.enums';

@Component({
  selector: 'app-base-single-column-image-button',
  imports: [
    EditableImageComponent,
    EditableButtonComponent
  ],
  templateUrl: './base-single-column-image-button.component.html',
  styleUrl: './base-single-column-image-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseSingleColumnImageButtonComponent extends BaseComponent {
  public supportedFileTypes = [FileType.WEBP, FileType.JPEG];

  override labelMap = {
    button: 'button',
    image: 'image'
  };

  override imageReference: ImageCoordinates = {
    coordinatesSystem: CoordinatesSystem.ScreenWidth,
    formatMap: {
      [ScreenWidthBreakpoints.XSmall]: ImageFormat.FourToThree,
      [ScreenWidthBreakpoints.Small]: ImageFormat.SixteenToNine,
      [ScreenWidthBreakpoints.Medium]: ImageFormat.SixteenToNine,
      [ScreenWidthBreakpoints.Large]: ImageFormat.SixteenToNine,
      [ScreenWidthBreakpoints.XLarge]: ImageFormat.SixteenToNine,
    }
  };
}